import React, { memo } from 'react';
import { View, Text, TextInput, StyleSheet } from 'react-native';
import { ADMIN_COLORS } from '@/constants/admin';
import { CreateEventFormData, CreateEventFormErrors } from '@/types/admin/createEvent';

interface EventSettingsSectionProps {
  formData: CreateEventFormData;
  errors: CreateEventFormErrors;
  onFieldChange: (field: keyof CreateEventFormData, value: string | Date) => void;
}

export const EventSettingsSection = memo<EventSettingsSectionProps>(({
  formData,
  errors,
  onFieldChange,
}) => {
  return (
    <View style={styles.section}>
      <Text style={styles.sectionTitle}>Settings</Text>
      
      {/* RSVP Limit */}
      <View style={styles.inputGroup}>
        <Text style={styles.label}>Max Attendees</Text>
        <TextInput
          style={[styles.textInput, errors.rsvpLimit && styles.inputError]}
          placeholder="0 for unlimited"
          value={formData.rsvpLimit}
          onChangeText={(text) => onFieldChange('rsvpLimit', text)}
          placeholderTextColor={ADMIN_COLORS.TEXT_TERTIARY}
          keyboardType="numeric"
        />
        {errors.rsvpLimit && <Text style={styles.errorText}>{errors.rsvpLimit}</Text>}
        <Text style={styles.helperText}>Enter 0 for unlimited attendees</Text>
      </View>

      {/* Internal Notes */}
      <View style={styles.inputGroup}>
        <Text style={styles.label}>Internal Notes</Text>
        <TextInput
          style={styles.textArea}
          placeholder="Internal Notes"
          value={formData.internalNotes}
          onChangeText={(text) => onFieldChange('internalNotes', text)}
          placeholderTextColor={ADMIN_COLORS.TEXT_TERTIARY}
          multiline
          numberOfLines={3}
          textAlignVertical="top"
        />
      </View>
    </View>
  );
});

EventSettingsSection.displayName = 'EventSettingsSection';

const styles = StyleSheet.create({
  section: {
    marginBottom: 24,
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: ADMIN_COLORS.TEXT_PRIMARY,
    marginBottom: 16,
  },
  inputGroup: {
    marginBottom: 16,
  },
  label: {
    fontSize: 14,
    fontWeight: '500',
    color: ADMIN_COLORS.TEXT_PRIMARY,
    marginBottom: 8,
  },
  textInput: {
    backgroundColor: ADMIN_COLORS.BACKGROUND.SECONDARY,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: ADMIN_COLORS.BORDER,
    paddingHorizontal: 12,
    paddingVertical: 12,
    fontSize: 16,
    color: ADMIN_COLORS.TEXT_PRIMARY,
    minHeight: 48,
  },
  textArea: {
    backgroundColor: ADMIN_COLORS.BACKGROUND.SECONDARY,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: ADMIN_COLORS.BORDER,
    paddingHorizontal: 12,
    paddingVertical: 12,
    fontSize: 16,
    color: ADMIN_COLORS.TEXT_PRIMARY,
    minHeight: 100,
  },
  inputError: {
    borderColor: ADMIN_COLORS.ERROR,
  },
  errorText: {
    fontSize: 12,
    color: ADMIN_COLORS.ERROR,
    marginTop: 4,
  },
  helperText: {
    fontSize: 12,
    color: ADMIN_COLORS.TEXT_TERTIARY,
    marginTop: 4,
  },
});
